import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import AnalysisChartCard from "./ChartCard";

const data = [
  { name: "Supplies", value: 2.5 },
  { name: "Salaries", value: 2.3 },
  { name: "Other Expenses", value: 6.2 },
];

const COLORS = ["#00032A", "#6226EF", "#27AE60"];

const RevenueExpensesPieChart = () => {
  return (
    <AnalysisChartCard
      headerTitle="Transaction Breakdown"
      subText="in thousands"
    >
      <ResponsiveContainer width="100%" height="80%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={200}
            fill="#8884d8"
            label={({ name }) => `${name}`} // only show value on the slice
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => `${value}`}
            labelFormatter={(label) => `${label}`}
          />
          {/* Removed the <Legend /> */}
        </PieChart>
      </ResponsiveContainer>
    </AnalysisChartCard>
  );
};

export default RevenueExpensesPieChart;
